export let dataProps = {
    id: 0,
    staff_id: null,
    voucher_number: '',
    date_of_loan: new Date(),
    notes: '',
    repayment_starts_from: new Date(),
    repayment_amount: 0,
    loan_amount: 0,
    loan_balance: 0,
    store_id: null,
    bank_id: null,
    repayment_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/employeeLoan/properties.js